<template>
	<el-card :body-style="{ padding: '0px' }">
		<div slot="header" class="message header">
			<img src="../image/send_new_message.svg" class="header-icon">
			<span class="head-title-col">Send New Message</span>
		</div>
		<div class="message-form">
			<div class="suggest" v-if="suggested">
				<h5>Suggested Messages</h5>
				<el-row :gutter="20">
					<el-col v-for="(suggest, i) in suggested" :key="i" :span="8">
						<el-card :body-style="{ padding: '10px 15px' }"
							:shadow="(suggest == text) ? 'always' : 'hover'"
							@click.native="setMessage(suggest)">
							{{ suggest }}
						</el-card>
					</el-col>
				</el-row>
			</div>
			<ProviderSelect v-if="allPatientsChosen && patientProviderProfileList.length > 1" 
				:profile-map="patient.profile_map"
				@providerSelect="setMessageProvider"></ProviderSelect>
			<el-input
			  type="textarea"
			  :disabled="allPatientsChosen && (patient.provider && patient.provider.length > 1) && !messageProvider"
			  :autosize="{ minRows: 2, maxRows: 10 }"
			  :placeholder="messagePlaceholder"
			  v-model="text">
			</el-input>
			<div class="action">
				<el-button @click="send" type="primary"
					v-bind:disabled="!canSend || sending">
					Send Message
				</el-button>
			</div>
		</div>
	</el-card>
</template>

<script>
import OverviewCard from '..'
import { mapState, mapActions, mapGetters } from 'vuex'
import MessageTable from './Table'
import ProviderSelect from './ProviderSelect'

export default {
	name: 'patient-direct-message-card',
	extends: OverviewCard,

	data() {
		return {
			title: '',
			text: '',
			messageProvider: null
		}
	},

	mounted() {
		if(this.patientProviderProfileList && this.patientProviderProfileList.length == 1)
			this.messageProvider = this.patientProviderProfileList[0].provider
	},

	methods: {
		...mapActions('provider', [
			'createPatientMessage'
		]),
		setMessage(message) {
			this.text = message
		},
		send() {
			if (! this.canSend)
				return

			this.createPatientMessage({
				patient: this.patient.id,
				text: this.text,
				provider: this.messageProvider,
				ref_type: 'message'
			})
			.then(() => {
				this.reset()
			})
		},
		reset() {
			this.title = ''
			this.text = ''
		},
		setMessageProvider(provider) {
			this.messageProvider = provider
		}
	},

	computed: {
		...mapGetters('provider', [
			'getPatientMessages',
			'getPatientMessagingState',
			'getPatientProviderProfileList'
		]),
		...mapGetters('content', [
			'getContentKey'
		]),
		patientProviderProfileList() {
			return this.getPatientProviderProfileList(this.patient.id)
		},
		suggested() {
			return this.getContentKey('label', 'all', 'suggest')
		},
		canSend() {
			return this.text.trim().length > 0
		},
		sending() {
			return this.getPatientMessagingState(this.patient.id)
		},
		patientMessage() {
			return this.getPatientMessages(this.patient.id)
				.filter((message) => (message.status !== 'ready'))
				.sort((a, b) => (a.time - b.time))
		},
		messagePlaceholder() {
			if(this.allPatientsChosen && this.patientProviderProfileList.length > 1 && !this.messageProvider)
				return 'Select a doctor from above who would like to send a message to ' + this.patient.name
			else
				return 'Enter a message to send directly to ' + this.patient.name

		}
	},

	components: {
		MessageTable,
		ProviderSelect
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
.message-form {
	padding: 10px 15px;

	.suggest {
		background: lighten(#2d3e4f, 70%);
		border-radius: 4px;
		padding: 2px 10px;
		margin-bottom: 15px;
		h5 {
			color: #7f7f7f;
			margin-top: 10px;
		}
	}

	.action {
		padding-top: 10px;
		text-align: right;

		.el-button {
			font-weight: 700;
		}
	}
}
.header-icon {
	height: 43px !important;
	margin-top: -1px !important;
}
</style>
